import { Checkbox, Col, Form, Radio, Row, Typography } from 'antd';
import { useIntl } from 'react-intl';
import { OsXFinancialCompareValueBy } from '@/core/domain/questReport/Reports/OsXFinancial/OsXFinancial.types';

const OsXFinancialWithoutFinancialDivergentValueForm = () => {
  const intl = useIntl();
  const { Title } = Typography;

  return (
    <Row gutter={[24, 24]}>
      <Col sm={24}>
        <Title level={5}>
          {intl.formatMessage({
            id: 'movimentOsXFinancial.form.reportType.compareDivergentValue',
          })}
        </Title>

        <Form.Item
          name="compareValueBy"
          initialValue={OsXFinancialCompareValueBy.grossValue}
          noStyle
        >
          <Radio.Group optionType="button" buttonStyle="solid" size="large">
            <Radio value={OsXFinancialCompareValueBy.grossValue}>
              {intl.formatMessage({
                id: 'movimentOsXFinancial.form.reportType.grossValue',
              })}
            </Radio>
            <Radio value={OsXFinancialCompareValueBy.netValue}>
              {intl.formatMessage({
                id: 'movimentOsXFinancial.form.reportType.netValue',
              })}
            </Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      <Col>
        <Form.Item
          name="onlyOsWithoutFinancialRecord"
          initialValue={false}
          valuePropName="checked"
        >
          <Checkbox>
            {intl.formatMessage({
              id: 'movimentOsXFinancial.form.reportType.onlyTtheUnregistered',
            })}
          </Checkbox>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default OsXFinancialWithoutFinancialDivergentValueForm;
